<template>
	<div v-if="appuntamenti.length > 0">
		<div v-for="app in appuntamenti" :key="app">
			<b-card title="Card Title" class="sa-agenda-card-max-height" no-body>
				<b-card-header header-tag="nav">
					<span class="sa-settimana">{{ app }}</span>
				</b-card-header>
				<b-card-body class="text-center" style="overflow: auto; height: 100%">
					<agenda-appuntamenti-component ref="cmpAgendaAppuntamenti"> </agenda-appuntamenti-component>
				</b-card-body>
			</b-card>
		</div>
	</div>
	<div v-else>
		<div>test</div>
	</div>
</template>

<script>
import UtilityMixin from "../../utility/UtilityMixin";
import moment from "moment";
export default {
	props: {
		riferimento: {
			type: String,

			default: () => {
				return moment(new Date()).format("DD-MM-YYYY");
			},
		},
	},
	mixins: [UtilityMixin],
	data() {
		return {
			pathResourceAgendaAppuntamenti: "/agendaappuntamenti",
			idAgenda: null,
			appuntamenti: [],
		};
	},
	mounted() {
		this.idAgenda = this.$route.params.id;
	},
	methods: {
		loadData(dataSelezionata) {
			let dataRiferimento = new Date(dataSelezionata);
			UtilityMixin.methods.loadDataResources(this.pathResourceAgendaAppuntamenti, { idAgenda: this.idAgenda, dataRiferimento: moment(dataRiferimento).format("YYYY-MM-DD") }, this.loadDataSuccess, this.loadDataError);
		},
		loadDataSuccess(response) {
			console.log(response);
		},
		loadDataError(error) {
			console.log(error);
		},
	},
};
</script>

<style lang="scss" scoped></style>
